export default __webpack_public_path__ + "static/media/IvyMode-SemiBold.df0c6a3b.woff2";